import React, {useEffect, useImperativeHandle} from "react";
import {Col, Form, Input, Row, Select, DatePicker, TreeSelect, message} from "antd";
import {useModel, useModelDispatchers} from "../../../models/index";
import {CM_ACTION_TYPE} from "../../../utils/constants";
import moment from "moment";
import CmDictService from "../../../models/CmDictService";
import {useHistory} from "react-router";
import {goPage} from "../../layout/pageDefinition";
import { useState } from "react";

/*const tailLayout = {
    /!*wrapperCol: {
        offset: 0,
        span: 12,
    },*!/
    labelCol: {span: 3}
};*/

export default function ({formRef, actionType}) {
    const history = useHistory();
    const [form] = Form.useForm();

    const [{userInfo}] = useModel("global");
    const {orgId, orgName, userName,} = userInfo;
    const nowTime = moment().format("YYYY-MM-DD HH:mm:ss");

    const {closeNav} = useModelDispatchers("nav");
    const [{orgDict, warehouseDict, shelveDict},] = useModel("cmDict");
    const [newShelveDict,setNewShelveDict] = useState(shelveDict)
    const [{
        check,
        checkDetailList,
        checkStatistic,
    }, {
        insert,
        update,
        setCheck,
        loadCheck,
        setCheckDetailList,
    }] = useModel("stockCheck");
    useEffect(() => {
        const {differenceAmount} = checkStatistic;
        form.setFieldsValue({
            inventoryResults: differenceAmount === 0 ? 0 : differenceAmount > 0 ? 1 : -1
        })
    }, [checkStatistic])
    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            const dateFormat = 'YYYY-MM-DD';
            const {startTime, endTime} = check;
            form.setFieldsValue({
                ...check,
                startTime: startTime ? moment(startTime, dateFormat) : null,
                endTime: endTime ? moment(endTime, dateFormat) : null,
            });
        } else {
            form.setFieldsValue({
                orgId: orgId,
                createUser: userName,
                createTime: nowTime,
            })
        }

    }, [check]);
    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        update: () => {
            // if (!!!checkDetailList || checkDetailList.length === 0) {
            //     message.error("盘点明细数据为空!");
            // } else {
            form.validateFields().then(data => {
                const {id} = check;
                update({
                    showMsg: true,
                    data: {
                        id,
                        ...data,
                        details: checkDetailList,
                        ...checkStatistic,

                    }
                }).then(r => r);
            });
            // }
        },
        insert: (setSaveBtnDisabled) => {
            // if (!!!checkDetailList || checkDetailList.length === 0) {
            //     message.error("盘点明细数据为空!");
            // } else {
            form.validateFields().then(data => {
                setSaveBtnDisabled(true);
                insert({
                    showMsg: true, data: {
                        ...data,
                        details: checkDetailList,
                        ...checkStatistic,
                        orgId: orgId,
                        createUser: userName,
                        createTime: nowTime,
                    }
                }).then(retData => {
                    loadCheck({showMsg: false, data: retData}).then(() => {
                        closeNav();
                        goPage(history, "4-2-1");
                    });
                });
            });
            // }
        },
        reset: () => {
            form.resetFields();
        },
    }));
    const _onChange = (value,option)=>{
        let filterShelve = shelveDict.filter(el=>{
            if(el.warehouseId==value){
                return el
            }
        })
        setNewShelveDict(filterShelve)
    }

    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
            onValuesChange={
                e => {
                    if (e["warehouseId"]) {
                        setCheckDetailList([]);
                    }
                    setCheck({...check, ...e})
                }
            }
        >

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="inventoryListCode"
                        label="盘库单号"
                    >
                        <Input disabled={true} placeholder="盘库单号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="orgId"
                        label="盘库机构"
                        rules={[{required: true, message: '盘库机构是必输项',}]}
                    >
                        <TreeSelect
                            disabled={actionType === CM_ACTION_TYPE.EDIT}
                            showSearch
                            allowClear
                            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                            placeholder="请选择组织机构"
                            treeDefaultExpandAll
                            treeData={orgDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="warehouseId"
                        label="仓库"
                        rules={[{required: true, message: '仓库字段是必输项',}]}
                    >
                        <Select
                            disabled={actionType === CM_ACTION_TYPE.EDIT}
                            showSearch
                            allowClear={true}
                            placeholder="选择盘点仓库"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            onChange={_onChange}
                            options={warehouseDict.map(el => ({
                                key: el.key,
                                value: el.value,
                                label: el.label,
                            }))}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="shelvesId"
                        label="货架"
                        rules={[{required: false, message: '货架字段是必输项',}]}
                    >
                        <Select
                            disabled={actionType === CM_ACTION_TYPE.EDIT}
                            mode="multiple"
                            showSearch
                            allowClear={true}
                            placeholder="选择货架"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={newShelveDict.map(el => ({
                                key: el.key,
                                value: el.value,
                                label: el.label,
                            }))}
                        />
                    </Form.Item>
                </Col>

            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="startTime"
                        label="起始时间"
                    >
                        <DatePicker placeholder="起始时间" style={{width: "100%"}}/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="endTime"
                        label="结束时间"
                    >
                        <DatePicker placeholder="结束时间" style={{width: "100%"}}/>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        name="inventoryResults"
                        label="结果"
                    >
                        <Select
                            showSearch
                            disabled={true}
                            allowClear={true}
                            placeholder=""
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={CmDictService.getCheckResultDict()}
                        />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        name="inventoryListDesc"
                        label="备注"
                        // labelCol={{span: 3}}
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
                </Col>
            </Row>

            {/*<Row>
                <Col span={6}>
                    <Form.Item
                        name="inventoryBook"
                        label="账面库存量"
                    >
                        <Input disabled={true} placeholder="账面库存量"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="inventoryPhysical"
                        label="实物盘点量"
                    >
                        <Input disabled={true} placeholder="实物盘点量"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="differenceTotal"
                        label="差异总量"
                    >
                        <Input disabled={true} placeholder="差异总量"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="scrapTotal"
                        label="报废总量"
                    >
                        <Input disabled={true} placeholder="报废总量"/>
                    </Form.Item>
                </Col>
            </Row>*/}

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="createUser"
                        label="制单人"
                    >
                        <Input disabled={true} placeholder="制单人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="createTime"
                        label="制单时间"
                    >
                        <Input disabled={true} placeholder="制单时间"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="updateUser"
                        label="修改人"
                    >
                        <Input disabled={true} placeholder="修改人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="updateTime"
                        label="修改时间"
                    >
                        <Input disabled={true} placeholder="修改时间"/>
                    </Form.Item>
                </Col>
            </Row>

        </Form>
    )
}